import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { ResponseModel } from 'src/app/shared/models/ResponseModel';

@Injectable({
    providedIn: 'root'
})
export class InfoCandidateStagesService {
    private apiUrl = environment.backUrlApi + 'InfoCandidateStage';
    private http = inject(HttpClient);

    saveStage(dto: any): Observable<ResponseModel<any>> {
        return this.http.post<ResponseModel<any>>(`${this.apiUrl}/info-candidate-stage`, dto);
    }
}
